var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBetPanel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12h3.75V8.25H6.5V12zm0-5.25h9V3h-9v3.75zM11.75 12h3.75V8.25h-3.75V12zM6.5 13.5c-.412 0-.766-.147-1.059-.44A1.445 1.445 0 015 12V3c0-.413.147-.766.441-1.06.293-.293.647-.44 1.059-.44h9c.412 0 .766.147 1.06.44.293.294.44.647.44 1.06v9c0 .412-.147.766-.44 1.06-.294.293-.647.44-1.06.44h-9zm-3 3c-.413 0-.765-.147-1.059-.44A1.445 1.445 0 012 15V5.25c0-.213.072-.39.216-.535A.725.725 0 012.75 4.5c.212 0 .39.072.535.215a.728.728 0 01.215.535V15h9.75c.213 0 .39.072.534.216a.724.724 0 01.216.534c0 .213-.072.39-.216.534a.724.724 0 01-.534.216H3.5z",
    fill: "#fff"
  })));
}
export default SvgBetPanel;